import { buildApiUrl, createHeaders } from "./apiClient";
import { getCurrentUserId } from "./authService";

let queue = [];
let flushTimer = null;
const FLUSH_INTERVAL = 5000;
const MAX_QUEUE = 20;

function getHeaders() {
  const userId = getCurrentUserId();
  return createHeaders({ json: true, userId });
}

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(flush, FLUSH_INTERVAL);
}

async function flush() {
  flushTimer = null;
  if (queue.length === 0) return;
  const batch = queue.splice(0, MAX_QUEUE);
  try {
    await fetch(buildApiUrl("/api/analytics/track"), {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({ events: batch }),
      keepalive: true,
    });
  } catch {
    // silently drop — analytics should never block UX
  }
}

// Analytics are non-essential: only send once the visitor has accepted them
// via the cookie banner ("all"). "essential" or no choice => no tracking.
function analyticsAllowed() {
  try {
    return localStorage.getItem("gwbi_cookie_consent") === "all";
  } catch {
    return false;
  }
}

export function trackEvent(event, { targetType, targetId, metadata } = {}) {
  if (!analyticsAllowed()) return;
  queue.push({
    event,
    target_type: targetType || null,
    target_id: targetId || null,
    metadata: metadata || null,
  });
  if (queue.length >= MAX_QUEUE) {
    flush();
  } else {
    scheduleFlush();
  }
}

export function trackPageView(path) {
  trackEvent("page_view", { targetType: "page", targetId: path });
}

export function trackClick(targetType, targetId) {
  trackEvent("click", { targetType, targetId });
}

export function trackSearch(query) {
  trackEvent("search", { metadata: { query } });
}

// Flush on page unload
if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", flush);
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
